import Comp from "./CategoryFilters";

export default Comp;
